import { _request, APIBasePaginatedResponse, APIBaseResponse,APIMethod } from '..';
import { buildQueryParams } from '../apiHelpers';
import { PaginatedRequestParamsBase } from '../Models/CommonRequestModels';
import { UserTenantMembershipStatusProps } from '../TenantUserMembership/TenantUserMembershipApiTypeDefs';

const PROFILES_PATH_PREFIX = '/profiles';
const TENANTS_PATH_PREFIX = '/tenants';
const USER_GROUP_PATH_PREFIX = 'usergroupmemberships';

export interface IUser {
    userId: string;
    oasysId?: string;
    startDate?: string;
    endDate?: string;
    profile: {
        firstName: string;
        lastName: string;
        principalName: string;
        companyKey: string;
        email: string;
    }
}

type APIUserGroupUserPostParams = {
    tenantId: string;
    userGroupId: string;
    userId: string;
}

export type APIUserGroupsUsersGetParams = PaginatedRequestParamsBase & {
    tenantId: string;
    usergroupId: string;
    rowsCount?: number;
    retries?: number;
    status?: string[];
};

type APIUserGroupsUsersCreateResponse = APIBaseResponse<''>;

export type APIUserGroupsUsersGetSingleResponse = IUser & UserTenantMembershipStatusProps

type APIUserGroupsUsersGetResponse = APIBasePaginatedResponse<Array<APIUserGroupsUsersGetSingleResponse>>;

type APIUserGroupsUsersDeleteParams = {
    tenantId: string;
    userGroupId: string;
    userId: string;
};

type APIUserGroupsUsersDeleteResponse = APIBaseResponse<''>;

export const APIUserGroupsUsersGetList: APIMethod<APIUserGroupsUsersGetParams, APIUserGroupsUsersGetResponse> = (params) => {
    const queryParams = buildQueryParams(params, [{ key : 'status' }]);
    const endPoint = `${PROFILES_PATH_PREFIX}${TENANTS_PATH_PREFIX}/${params.tenantId}/${USER_GROUP_PATH_PREFIX}`;
    const requestPath = `${endPoint}` + (queryParams && `?${queryParams}`);
    return _request('GET', requestPath, undefined, params.signal, params.retries);
};

export const APIUserGroupsUserPost: APIMethod<APIUserGroupUserPostParams, APIUserGroupsUsersCreateResponse> = params => {
    return _request('POST', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${USER_GROUP_PATH_PREFIX}`, {
        userId: params.userId,
        userGroupId: params.userGroupId,
    });
};

export const APIUserGroupsUsersDelete: APIMethod<APIUserGroupsUsersDeleteParams, APIUserGroupsUsersDeleteResponse> = params => {
    return _request('DELETE', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${USER_GROUP_PATH_PREFIX}?usergroupId=${params.userGroupId}&userId=${params.userId}`);
};
